import React from 'react';
import { apiCreateForumPost, apiIsLoggedIn } from '../api/api';
import ForumTitleField from '../components/fields/ForumTitleField';
import ForumContentField from '../components/fields/ForumContentField';
import TopBarForum from '../components/topbars/TopBarForum';

class CreatePostPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            content: '',
        };

        this.handleChangeTitle = this.handleChangeTitle.bind(this);
        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handlePostSubmit = this.handlePostSubmit.bind(this);
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            window.location.href = '/';
        }
    }

    handleChangeTitle(event) {
        this.setState({
            ...this.state,
            title: event.target.value,
        });
    }

    handleChangeContent(event) {
        this.setState({
            ...this.state,
            content: event.target.value,
        });
    }

    async handlePostSubmit(event) {
        event.preventDefault();

        const result = await apiCreateForumPost(this.state.title, this.state.content, []);

        if (result.ok) {
            const resultJson = await result.json();
            const postId = resultJson.post_id;

            window.location.href = `/post/${postId}`;
        }
    }

    render() {
        return (
            <div>
                <TopBarForum />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                    <form onSubmit={this.handlePostSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <ForumTitleField value={this.state.title} onChange={this.handleChangeTitle} />
                        <ForumContentField value={this.state.content} onChange={this.handleChangeContent} />
                        <input type="submit" value="Submit" />
                    </form>
                </div>
            </div>
        )
    }
}

export default CreatePostPage;